module.exports = __webpack_public_path__ + "static/media/discord.533b6d91.svg";